import actionTypes from '../constants/action-types';

const startWLDomainPurchase = (triggerId) => ({
  type: actionTypes.START_WL_DOMAIN_PURCHASE,
  payload: { triggerId },
});

export default startWLDomainPurchase;
